import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./UserChildsUIHelpers";

const UserChildsUIContext = createContext();

export function useUserChildsUIContext() {
  let scc = useContext(UserChildsUIContext);

  return scc;
}

export const UserChildsConsumer = UserChildsUIContext.Consumer;

export function UserChildsUIProvider({ customersUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openFetchCustomersDialog: customersUIEvents.openFetchCustomersDialog,
  };

  return (
    <UserChildsUIContext.Provider value={value}>
      {children}
    </UserChildsUIContext.Provider>
  );
}
